import { render, staticRenderFns } from "./OrderCommunications.vue?vue&type=template&id=a606b4d2&scoped=true"
import script from "./OrderCommunications.vue?vue&type=script&lang=js"
export * from "./OrderCommunications.vue?vue&type=script&lang=js"
import style0 from "./OrderCommunications.vue?vue&type=style&index=0&id=a606b4d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a606b4d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a606b4d2')) {
      api.createRecord('a606b4d2', component.options)
    } else {
      api.reload('a606b4d2', component.options)
    }
    module.hot.accept("./OrderCommunications.vue?vue&type=template&id=a606b4d2&scoped=true", function () {
      api.rerender('a606b4d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/AdminSummarySubs/OrderCommunications.vue"
export default component.exports